import { SET_IS_LOADING } from '../actions/set-is-loading';
import { FETCH_POST_REQUEST, FETCH_POST_SUCCESS, FETCH_POST_FAILURE } from '../actions/fetch-post';
import { FETCH_POSTS_REQUEST, FETCH_POSTS_SUCCESS, FETCH_POSTS_FAILURE } from '../actions/fetch-posts';
import {
  FETCH_USER_POSTS_REQUEST,
  FETCH_USER_POSTS_SUCCESS,
  FETCH_USER_POSTS_FAILURE,
} from '../actions/fetch-posts-by-owner-id';
import { FETCH_COMMENTS_REQUEST, FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_FAILURE } from '../actions/fetch-comments';
import { FETCH_MEMBERS_REQUEST, FETCH_MEMBERS_SUCCESS, FETCH_MEMBERS_FAILURE } from '../actions/fetch-members';
import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
} from '../actions/fetch-notifications';
import { FETCH_SEARCH_SUCCESS, FETCH_SEARCH_FAILURE } from '../actions/fetch-search';
import { SEARCH_CLEAR_RESULTS } from '../actions/search';
import { FETCH_FOLLOWERS_REQUEST, FETCH_FOLLOWERS_FAILURE, FETCH_FOLLOWERS_SUCCESS } from '../actions/fetch-followers';
import { FETCH_FOLLOWING_REQUEST, FETCH_FOLLOWING_FAILURE, FETCH_FOLLOWING_SUCCESS } from '../actions/fetch-following';

// eslint-disable-next-line complexity
export default function isLoading(state = {}, action) {
  switch (action.type) {
    case SET_IS_LOADING:
      return setIsLoading(state, action.payload);
    case FETCH_POST_REQUEST: {
      return setIsLoading(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoading: true,
      });
    }
    case FETCH_POST_SUCCESS:
    case FETCH_POST_FAILURE:
      return setIsLoading(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoading: false,
      });

    case FETCH_USER_POSTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'profile-posts',
        isLoading: true,
      });
    }
    case FETCH_USER_POSTS_SUCCESS:
    case FETCH_USER_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'profile-posts',
        isLoading: false,
      });
    case FETCH_POSTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'posts',
        isLoading: true,
      });
    }
    case FETCH_POSTS_SUCCESS:
    case FETCH_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'posts',
        isLoading: false,
      });
    case FETCH_COMMENTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'comments',
        id: action.payload.postSlug,
        isLoading: true,
      });
    }
    case FETCH_COMMENTS_SUCCESS:
    case FETCH_COMMENTS_FAILURE:
      return setIsLoading(state, {
        entity: 'comments',
        id: action.payload.postSlug,
        isLoading: false,
      });

    case FETCH_MEMBERS_REQUEST: {
      return setIsLoading(state, {
        entity: 'members',
        isLoading: true,
      });
    }
    case FETCH_MEMBERS_SUCCESS:
    case FETCH_MEMBERS_FAILURE:
      return setIsLoading(state, {
        entity: 'members',
        isLoading: false,
      });

    case FETCH_NOTIFICATIONS_REQUEST:
      return setIsLoading(state, {
        entity: 'notifications',
        isLoading: true,
      });
    case FETCH_NOTIFICATIONS_SUCCESS:
    case FETCH_NOTIFICATIONS_FAILURE:
      return setIsLoading(state, {
        entity: 'notifications',
        isLoading: false,
      });

    case FETCH_SEARCH_SUCCESS:
    case FETCH_SEARCH_FAILURE:
    case SEARCH_CLEAR_RESULTS:
      return setIsLoading(state, {
        entity: 'search',
        isLoading: false,
      });

    case FETCH_FOLLOWERS_REQUEST:
      return setIsLoading(state, {
        entity: 'followers',
        isLoading: true,
      });

    case FETCH_FOLLOWERS_FAILURE:
    case FETCH_FOLLOWERS_SUCCESS:
      return setIsLoading(state, {
        entity: 'followers',
        isLoading: false,
      });

    case FETCH_FOLLOWING_REQUEST:
      return setIsLoading(state, {
        entity: 'following',
        isLoading: true,
      });

    case FETCH_FOLLOWING_FAILURE:
    case FETCH_FOLLOWING_SUCCESS:
      return setIsLoading(state, {
        entity: 'following',
        isLoading: false,
      });

    default:
      return state;
  }
}

function setIsLoading(state, { entity, id = '', isLoading }) {
  return {
    ...state,
    [entity]: {
      ...state[entity],
      [id]: isLoading,
    },
  };
}



// WEBPACK FOOTER //
// ./app/reducers/is-loading.js